import React, { useState, useEffect } from 'react';
import { trackFormSubmission, trackFormFieldInteraction } from '../utils/analytics';

export default function ContactForm({ t, language }) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    notes: '',
    languagePreference: language,
  });

  useEffect(() => {
    setFormData(f => ({ ...f, languagePreference: language }));
  }, [language]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // trackFormFieldInteraction('contact', name, 'change'); // This is too noisy
  };

  const encode = (data) => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...formData })
    })
      .then(() => {
        trackFormSubmission('contact', true);
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            'send_to': 'AW-16528553808',
            'value': 1.0,
            'currency': 'USD',
            'transaction_id': Date.now().toString()
          });
        }
        window.location.href = "/contact/thank-you";
      })
      .catch(error => {
        trackFormSubmission('contact', false);
        alert(error);
      });
  };

  return (
    <form
      name="contact"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      onSubmit={handleSubmit}
      className="space-y-6 w-full max-w-lg border-2 border-[#bfa76a] rounded-xl p-10 bg-white shadow-lg"
    >
      <input type="hidden" name="form-name" value="contact" />
      <p style={{ display: 'none' }}>
        <label>
          Don't fill this out if you're human: <input name="bot-field" />
        </label>
      </p>
      {/* Form Header */}
      <div className="text-center mb-6 pb-12">
        <h2 className="text-2xl font-playfair text-[#181c24] mb-2">
          {t.contact.formHeaderTitle}
        </h2>
        <p className="text-sm text-[#1a2233]/80">
          {t.contact.formHeaderSubtitle}
        </p>
      </div>
      {/* Name Fields */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor="firstName" className="block mb-1 text-xs font-medium text-[#1a2233]">{t.contact.firstName}</label>
          <input 
            type="text" 
            id="firstName" 
            name="firstName" 
            value={formData.firstName}
            onChange={handleChange}
            onBlur={() => trackFormFieldInteraction('contact', 'firstName', 'blur')}
            required 
            className="w-full border border-[#bfa76a]/20 rounded-lg p-2 bg-white focus:border-[#bfa76a] focus:ring-1 focus:ring-[#bfa76a] transition-colors text-sm" 
          />
        </div>
        <div>
          <label htmlFor="lastName" className="block mb-1 text-xs font-medium text-[#1a2233]">{t.contact.lastName}</label>
          <input 
            type="text" 
            id="lastName" 
            name="lastName" 
            value={formData.lastName}
            onChange={handleChange}
            onBlur={() => trackFormFieldInteraction('contact', 'lastName', 'blur')}
            required 
            className="w-full border border-[#bfa76a]/20 rounded-lg p-2 bg-white focus:border-[#bfa76a] focus:ring-1 focus:ring-[#bfa76a] transition-colors text-sm" 
          />
        </div>
      </div>
      {/* Email */}
      <div className="grid grid-cols-1">
        <div className="md:col-span-1">
          <label htmlFor="email" className="block mb-1 text-xs font-medium text-[#1a2233]">{t.contact.email}</label>
          <input 
            type="email" 
            id="email" 
            name="email" 
            value={formData.email}
            onChange={handleChange}
            onBlur={() => trackFormFieldInteraction('contact', 'email', 'blur')}
            required 
            className="w-full border border-[#bfa76a]/20 rounded-lg p-2 bg-white focus:border-[#bfa76a] focus:ring-1 focus:ring-[#bfa76a] transition-colors text-sm" 
          />
        </div>
      </div>
      {/* Notes */}
      <div>
        <label htmlFor="notes" className="block mb-1 text-xs font-medium text-[#1a2233]">{t.contact.notes}</label>
        <textarea 
          id="notes" 
          name="notes" 
          value={formData.notes}
          onChange={handleChange}
          onBlur={() => trackFormFieldInteraction('contact', 'notes', 'blur')}
          className="w-full border border-[#bfa76a]/20 rounded-lg p-2 bg-white focus:border-[#bfa76a] focus:ring-1 focus:ring-[#bfa76a] transition-colors text-sm" 
          rows="4"
        />
      </div>
      {/* Submit Button */}
      <button 
        type="submit" 
        className="w-full bg-[#bfa76a] text-white px-6 py-3 rounded-lg hover:bg-[#a8905d] transition-colors font-medium text-center justify-center"
      >
        {t.contact.requestConsultation}
      </button>
    </form>
  );
} 